<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="details"
      dateField="Date"
      numberField="ReceiveNumber"
    />

    <template v-if="details.VendorID">
      <kst-output field="VendorID" :data="details" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="VendorAlias" :data="details" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="VendorName" :data="details" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="VendorID" :data="details" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="VendorName" :data="details" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="VendorAddress" :data="details" :catalog="Catalog"/>
    <kst-output field="Comment" :data="details" :catalog="Catalog"/>
    <kst-created :data="details"/>
    <kst-last-updated :data="details"/>
    <kst-output field="WarehouseID" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RcvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>